var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video_set"},[(_vm.form.id)?_c('div',{staticClass:"dataMsg"},[_c('div',{staticClass:"video_set_title"},[_vm._v("直播配置")]),_c('dataBox',{attrs:{"dataMsg":_vm.form,"meeting_data":_vm.meeting_data},on:{"changeForm":_vm.changeForm}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }